
document.addEventListener("DOMContentLoaded", function () {

    const buttons = document.querySelectorAll(".wishlist-btn");

    if (!buttons.length) return;

    function getWishlist() {
        try {
            const data = JSON.parse(
                localStorage.getItem("wishlist") || "[]"
            );

            return Array.isArray(data) ? data : [];
        } catch (error) {
            return [];
        }
    }

   
function updateButton(button) {
    const productHandle = button.dataset.productHandle;
    const wishlist = getWishlist();
    const isActive = wishlist.includes(productHandle);

    // Homepage: only love icon
    if (button.classList.contains("wishlist-icon-only")) {
        button.innerHTML = isActive ? "❤️" : "♡";
        button.setAttribute("aria-label",
            isActive ? "Remove from Wishlist" : "Add to Wishlist"
        );
    }

    // Product page: love icon with text
    else {
        button.innerHTML = isActive
            ? "❤️ Remove from Wishlist"
            : "♡ Add to Wishlist";
    }

    button.classList.toggle("activee", isActive);
}


    buttons.forEach(function (button) {

        updateButton(button);

        button.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();

            const productHandle = button.dataset.productHandle;
            let wishlist = getWishlist();

            if (wishlist.includes(productHandle)) {
                wishlist = wishlist.filter(
                    handle => handle !== productHandle
                );
            } else {
                wishlist.push(productHandle);
            }

            localStorage.setItem(
                "wishlist",
                JSON.stringify(wishlist)
            );

            // একই product-এর অন্য button-ও update হবে
            document.querySelectorAll(".wishlist-btn").forEach(function (btn) {
                if (btn.dataset.productHandle === productHandle) {
                    updateButton(btn);
                }
            });
        });

    });

});
